import script from "./DentalHospitalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DentalHospitalTable.vue?vue&type=script&setup=true&lang=js"

import "./DentalHospitalTable.vue?vue&type=style&index=0&id=e1cab956&lang=css"

const __exports__ = script;

export default __exports__